import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';

import { InventoryService } from '../../services/inventory.service';
import { PackagingService } from 'app/services/packaging.service';
import { AlertService } from '../../alert';

@Component({
  selector: 'app-packaging-detail',
  providers: [InventoryService, PackagingService],
  templateUrl: './packaging-detail.component.html',
  styleUrls: ['./packaging-detail.component.css']
})
export class PackagingDetailComponent implements OnInit, AfterViewInit {

  @Input("order") order: any;
  @Input("activateLabel") activateLabel: boolean = false;
  @Output("onAddPack") addPack = new EventEmitter<any>();
  @Output("onDeletePack") deletePack = new EventEmitter<any>();
  @Output("onSelectLabel") selectLabel = new EventEmitter<any>();
  @Output("onFinalPackaging") finalPackaging = new EventEmitter<any>();
  
  packagingName: string = null;
  packagings: any[];
  orderPackagings: any[] = [];
  totalArticleWeight: number = 0;

  constructor(private packagingService: PackagingService, 
              private inventoryService: InventoryService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.load();

  }

  ngAfterViewInit() {
 
  }

  ngOnChanges(changes: any) {
    this.getOrderPackagings(this.order);
  }

  load() {
      this.getPackagings();
      this.getOrderPackagings(this.order);
      this.getTotalArticleWeight();
  }

  selectPackaging(packaging: any) {
      this.packagingName = packaging.name;
  }

  async getPackagings() {
    this.packagings = await this.packagingService.getPackagings().toPromise();
  }

  getOrderPackagings(order: any) {
      this.orderPackagings = this.order.orderPackagings;
  }

  pack() {
    this.addPack.emit(this.packagingName);
  }

  deletePackaging(packagingName: string) {
     this.deletePack.emit(packagingName);
  }

  selectNewLabel(){
    // keep track of how many selected labels and pass it to order-detail.component
    let checkButtons = document.querySelectorAll('input[type="checkbox"]:checked');
    let totalLabels = 0;
    let request: any[] = [];
    for (let i = 0; i < checkButtons.length; i++) {
      for (let packItem of this.orderPackagings) {
        if (checkButtons[i].id == packItem.packaging.name) {
          totalLabels = totalLabels + packItem.amount;
          // store packaging structure for emmit
          for (let pack of this.packagings) {
            if (pack.name == packItem.packaging.name) {
              for (let j = 0; j < packItem.amount; j++) {
                let packaging = {
                  packageType: packItem.packaging.name,
                  length: pack.length,
                  height: pack.height,
                  width: pack.depth,
                  weight: pack.weight
                }
                request.push(packaging);
              }
            }
          }
        }
      }
    }
    // add articles weight distributed through the n packages
    for (let k = 0; k < request.length; k++) { // or calculate this distribution before and create the packaging request later/inside??
      request[k].weight = request[k].weight + (this.totalArticleWeight / request.length);
      request[k].weight = request[k] / 1000; // send weight in Kg
    }
    this.finalPackaging.emit(request);  
    this.selectLabel.emit(totalLabels);
  }

  getTotalArticleWeight() {
    // add articles weight distributed through the n packages
    this.totalArticleWeight = 0;
    // search article per reference
    this.inventoryService.getArticles()
    .subscribe(
      data => {
        for (let article of this.order.orderArticles) {
          for (let item of data) {
            if (article.articleRef ==  item.articleRef) {
              this.totalArticleWeight = this.totalArticleWeight + (article.numberOfItems * item.weight);
            }
          }
        }
        this.alertService.clear();
      },
      error => {
        this.alertService.error(error);
      });
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/packaging-detail/packaging-detail.component.ts